import * as React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

class ListGoogleSchemaMarkup extends React.Component {
  static propTypes = {
    itemUrls: PropTypes.arrayOf(PropTypes.string),
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'itemUrls' does not exist on type 'Readon... Remove this comment to see the full error message
    const { itemUrls } = this.props;

    if (_.isEmpty(itemUrls)) {
      return false;
    }

    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: itemUrls.map((elem: $TSFixMe, i: $TSFixMe) => ({
        '@type': 'ListItem',
        position: i + 1,
        url: elem,
      })),
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(markupJson)}
        </script>
      `,
    });

    return (
      <div className="rc-ListGoogleSchemaMarkup">
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default ListGoogleSchemaMarkup;
